/**
 * Preload media files (images/videos)
 *
 * @param {Array} imageUrls.
 */
export const preloadImages = (imageUrls) => {
  if (!imageUrls) return;

  imageUrls.forEach((imageUrl) => {
    const img = new Image();
    img.src = imageUrl;
  });
};

/**
 * Preload video files.
 *
 * @param {Array} videoUrls.
 */
export const preloadVideos = (videoUrls) => {
  if (!videoUrls) return;

  const container = document.createElement('div');
  const attr = document.createAttribute('style');
  attr.value = 'display: none';
  container.setAttributeNode(attr);
  document.body.appendChild(container);

  videoUrls.forEach((videoUrl) => {
    const video = document.createElement('video');
    video.src = videoUrl;
    container.appendChild(video);
  });
};



// WEBPACK FOOTER //
// ./src/utilities/preloadMedia.js